export enum E_EstadoFormPrograma {
  Lectura = 1,
  Agregar = 2,
  Cerrar = 3,
}

export enum E_EstadoPlanificacion {
  EnConstruccion = 1,
  PlanInformado = 2,
  ResultadosEvaluacionInformados = 3,
  MedidasEnviadasProveedor = 4,
  MedidasAprobadas=5,
  EvidenciaEnviada = 6,
  AccionesAsignadas = 8,
  EvaluacionCerrada = 7
}

export enum E_EstadoMedida{
  NoAprobada = 1,
  Aprobada = 2,
  EvidenciaEnviada = 3,
  Cerrada = 4,
  Rechazado = 5
}